module.exports = __webpack_public_path__ + "static/media/whitelock.15863a54.svg";